import React from 'react'

import Svg from './svg'


export default function Timer2Icon({width, height, color, color2 = '--accent-color', ...props}) {
    color = getComputedStyle(document.documentElement)
        .getPropertyValue(color || '--on-content') || color
    color2 = getComputedStyle(document.documentElement)
        .getPropertyValue(color2) || color2

    return <Svg width={width || '16px'} height={height || '16px'} viewBox="0 0 100 100" version="1.1" xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g id="timer2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <path d="M50.5,96 C28.1324676,96 10,77.8675324 10,55.5 C10,33.1324676 28.1324676,15 50.5,15 C72.8675324,15 91,33.1324676 91,55.5 C91,77.8675324 72.8675324,96 50.5,96 Z" id="Combined-Shape" fill={color}></path>
            <rect id="Rectangle" fill={color2} transform="translate(84.606602, 21.606602) rotate(45.000000) translate(-84.606602, -21.606602) " x="75.1066017" y="16.1066017" width="19" height="11"></rect>
            <rect id="Rectangle-Copy" fill={color2} x="41" y="2" width="19" height="11"></rect>
            <path d="M54,56 C54,58.209139 52.209139,60 50,60 C47.790861,60 46,58.209139 46,56 L46,35 L50.0197754,25 L54,35 L54,56 Z" id="Combined-Shape" fill={color2}></path>
        </g>
    </Svg>
}
